'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _require = require('multiaddr'),
    Multiaddr = _require.Multiaddr;

var PeerId = require('peer-id');

var arrayEquals = require('libp2p-utils/src/array-equals');

var _require2 = require('./peer-record'),
    Protobuf = _require2.PeerRecord;

var _require3 = require('./consts'),
    ENVELOPE_DOMAIN_PEER_RECORD = _require3.ENVELOPE_DOMAIN_PEER_RECORD,
    ENVELOPE_PAYLOAD_TYPE_PEER_RECORD = _require3.ENVELOPE_PAYLOAD_TYPE_PEER_RECORD;
/**
 * @typedef {import('../../peer-store/address-book.js').Address} Address
 * @typedef {import('libp2p-interfaces/src/record/types').Record} Record
 */

/**
 * @implements {Record}
 */


var PeerRecord = /*#__PURE__*/function () {
  /**
   * The PeerRecord is used for distributing peer routing records across the network.
   * It contains the peer's reachable listen addresses.
   *
   * @class
   * @param {Object} params
   * @param {PeerId} params.peerId
   * @param {Multiaddr[]} params.multiaddrs - addresses of the associated peer.
   * @param {number} [params.seqNumber] - monotonically-increasing sequence counter that's used to order PeerRecords in time.
   */
  function PeerRecord(_ref) {
    var peerId = _ref.peerId,
        _ref$multiaddrs = _ref.multiaddrs,
        multiaddrs = _ref$multiaddrs === void 0 ? [] : _ref$multiaddrs,
        _ref$seqNumber = _ref.seqNumber,
        seqNumber = _ref$seqNumber === void 0 ? Date.now() : _ref$seqNumber;

    _classCallCheck(this, PeerRecord);

    this.domain = ENVELOPE_DOMAIN_PEER_RECORD;
    this.codec = ENVELOPE_PAYLOAD_TYPE_PEER_RECORD;
    this.peerId = peerId;
    this.multiaddrs = multiaddrs;
    this.seqNumber = seqNumber; // Cache

    this._marshal = undefined;
  }
  /**
   * Marshal a record to be used in an envelope.
   *
   * @returns {Uint8Array}
   */


  _createClass(PeerRecord, [{
    key: "marshal",
    value: function marshal() {
      if (this._marshal) {
        return this._marshal;
      }

      this._marshal = Protobuf.encode({
        peerId: this.peerId.toBytes(),
        seq: this.seqNumber,
        addresses: this.multiaddrs.map(function (m) {
          return {
            multiaddr: m.bytes
          };
        })
      }).finish();
      return this._marshal;
    }
    /**
     * Returns true if `this` record equals the `other`.
     *
     * @param {unknown} other
     * @returns {boolean}
     */

  }, {
    key: "equals",
    value: function equals(other) {
      if (!(other instanceof PeerRecord)) {
        return false;
      } // Validate PeerId


      if (!this.peerId.equals(other.peerId)) {
        return false;
      } // Validate seqNumber


      if (this.seqNumber !== other.seqNumber) {
        return false;
      } // Validate multiaddrs


      if (!arrayEquals(this.multiaddrs, other.multiaddrs)) {
        return false;
      }

      return true;
    }
  }]);

  return PeerRecord;
}();
/**
 * Unmarshal Peer Record Protobuf.
 *
 * @param {Uint8Array} buf - marshaled peer record.
 * @returns {PeerRecord}
 */


PeerRecord.createFromProtobuf = function (buf) {
  var peerRecord = Protobuf.decode(buf);
  var peerId = PeerId.createFromBytes(peerRecord.peerId);
  var multiaddrs = (peerRecord.addresses || []).map(function (a) {
    return new Multiaddr(a.multiaddr);
  });
  var seqNumber = Number(peerRecord.seq);
  return new PeerRecord({
    peerId: peerId,
    multiaddrs: multiaddrs,
    seqNumber: seqNumber
  });
};

PeerRecord.DOMAIN = ENVELOPE_DOMAIN_PEER_RECORD;
module.exports = PeerRecord;